import { trimNumber, num2str } from '@rc-component/mini-decimal';
export function getDecupleSteps(step) {
  const stepStr = typeof step === 'number' ? num2str(step) : trimNumber(step).fullStr;
  const hasPoint = stepStr.includes('.');
  if (!hasPoint) {
    return step + '0';
  }
  return trimNumber(stepStr.replace(/(\d)\.(\d)/g, '$1$2.')).fullStr;
}